/** API route map: URLS.Controller.PositionRate */
export const PositionRate = {
      Name: 'PositionRate/',
      GetAllPaginated: 'get-all-paginated',
      GetPositionCodes: 'get-position-codes',
      GetPayCodes: 'get-pay-codes',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
};
